import { render, staticRenderFns } from "./CollectionReductionTask.vue?vue&type=template&id=20ccbb66&scoped=true"
import script from "./CollectionReductionTask.vue?vue&type=script&lang=js"
export * from "./CollectionReductionTask.vue?vue&type=script&lang=js"
import style0 from "./CollectionReductionTask.vue?vue&type=style&index=0&id=20ccbb66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ccbb66",
  null
  
)

export default component.exports